import { render, staticRenderFns } from "./StudentPei.vue?vue&type=template&id=25fc0876"
import script from "./StudentPei.vue?vue&type=script&lang=js"
export * from "./StudentPei.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports